export const mutations = {
};

export default mutations;
